__turbopack_context__.v({
  "description": "style-module-scss-module__KOQ6Ta__description",
  "extraTopPaddingMobile": "style-module-scss-module__KOQ6Ta__extraTopPaddingMobile",
  "grid": "style-module-scss-module__KOQ6Ta__grid",
  "row": "style-module-scss-module__KOQ6Ta__row",
  "section": "style-module-scss-module__KOQ6Ta__section",
  "title": "style-module-scss-module__KOQ6Ta__title",
});
